/* eslint-disable */
import { debouncePromise } from '~/js/utils/helpers';
import { disableScrollForInputDrawer, enableScrollForInputDrawer } from '~/js/utils/dom';

function triggerAutoCompleteHooksCustomEvent(eventName) {
  const event = new Event(eventName);
  window.dispatchEvent(event);
}

export const algoliaHandler = () => ({
  init() {
    this.algoliaAutocompleteEnhance();
    this.algoliaInstantSearchEnhance();
  },

  algoliaAutocompleteEnhance() {
    document.addEventListener('DOMContentLoaded', function () {
      // Reset Algolia Search input on cancel button click in Mobile Search drawer.
      const autocompleteInput = document.getElementById('algolia-autocomplete-input-id');
      if (autocompleteInput) {
        let listenerAdded = false;
        autocompleteInput.addEventListener('click', function (event) {
          if (!listenerAdded) {
            if (event.target.matches('.aa-DetachedSearchButton') || event.target.closest('.aa-DetachedSearchButton')) {
              const detachedContainer = document.querySelector('.aa-DetachedContainer');

              const cancelButton = document.querySelector('.aa-DetachedFormContainer .aa-DetachedCancelButton');
              const SearchInputForm = document.querySelector('.aa-DetachedFormContainer .aa-Form');


              if (detachedContainer && SearchInputForm) {
                setTimeout(() => {
                  triggerAutoCompleteHooksCustomEvent('append-suggestions-mobile');
                }, 0);
              }

              if (cancelButton && SearchInputForm) {
                cancelButton.addEventListener('click', function () {
                  SearchInputForm.reset();
                  listenerAdded = true;
                });
              }
            }
          }
        });
      }
    });

    // Detect Algolia Mobile Search drawer is opened or closed to disable body scroll handling for iPhones

    let wasDetached = document.body.classList.contains('aa-Detached');

    function updateOverflow() {
      const isDetached = document.body.classList.contains('aa-Detached');
      if (isDetached && !wasDetached) {
        disableScrollForInputDrawer();
      } else if (!isDetached && wasDetached) {
        enableScrollForInputDrawer();
      }
      wasDetached = isDetached; // Update the previous state
    }

    const observer = new MutationObserver(function (mutations) {
      // MutationObserver to monitor changes to the body class
      mutations.forEach(function (mutation) {
        if (mutation.attributeName === 'class') {
          updateOverflow();
        }
      });
    });

    observer.observe(document.body, { attributes: true }); // Start observing the body element for attribute changes

    // Algolia Search Autocomplete custom hooks
    document.addEventListener('algolia.hooks.initialize', function () {
      // Add debounce delay to the Algolia search query for Products, Collections, Articles, and Pages.
      algoliaShopify.hooks.registerHook('beforeAutocompleteOptions', function (options) {
        const searchQueryDelay = 1000;

        if (Array.isArray(options.plugins) && options.plugins.length > 0) {
          for (let i = 0; i <= Math.min(3, options.plugins.length); i++) {
            if (typeof options.plugins[i].getSources === 'function') {
              const originalGetSources = options.plugins[i].getSources;
              const debouncedGetSourcesFunction = debouncePromise(function (...args) {
                return originalGetSources.apply(this, args);
              }, searchQueryDelay);

              options.plugins[i].getSources = function (...args) {
                return debouncedGetSourcesFunction.apply(this, args);
              };
            }
          }
        }

        return options;
      });

      // Main Search Panel Customization.
      algoliaShopify.hooks.registerHook(
        'beforeAutocompleteMainTemplate',
        function (_defaultTemplate, templateOptions, elements, displaySuggestions) {
          triggerAutoCompleteHooksCustomEvent('before-autocomplete-load');
          const { html, state } = templateOptions;
          return html`
            <div id="algolia-autocomplete-panel" class="aa-PanelLayout aa-Panel--scrollable">
              <div class="aa-PanelSections">
                <div class="aa-PanelSection--left">
                  ${displaySuggestions &&
                  html`
                    <div class="aa-SourceHeader">
                      <span class="aa-SourceHeaderTitle">${algoliaShopify.translations.suggestions}</span>
                      <div class="aa-SourceHeaderLine"></div>
                    </div>
                    ${elements.querySuggestionsPlugin}
                  `}
                  <div class="aa-SourceHeader aa-RelatedListings">
                    <span class="aa-SourceHeaderTitle">Related</span>
                  </div>
                  ${elements.collections}${elements.articles}${elements.pages}${elements.redirectUrlPlugin}
                </div>
                <div class="aa-PanelSection--right">
                  ${elements.products}
                  ${html`
                    <div class="aa-ViewAllBtnWrapper">
                      <a href="/search?q=${state.query}" class="component-btn aa-ViewAllBtn">VIEW ALL SEARCH RESULTS</a>
                    </div>
                  `}
                </div>
              </div>
            </div>
          `;
        },
      );

      // Main Products template - this comes when there are no other results except products and beforeAutocompleteMainTemplate doesn't work.
      algoliaShopify.hooks.registerHook(
        'beforeAutocompleteMainProductsTemplate',
        function (_defaultTemplate, templateOptions, elements) {
          triggerAutoCompleteHooksCustomEvent('before-autocomplete-load');
          const { html, state } = templateOptions;
          return html`
            <div id="algolia-autocomplete-panel" class="aa-PanelLayout aa-Panel--scrollable">
              <div class="aa-PanelSection">
                ${elements.products}
                ${html`
                  <div class="aa-ViewAllBtnWrapper">
                    <a href="/search?q=${state.query}" class="component-btn aa-ViewAllBtn">VIEW ALL SEARCH RESULTS</a>
                  </div>
                `}
              </div>
            </div>
          `;
        },
      );

      // Main Search Panel - No results
      algoliaShopify.hooks.registerHook(
        'beforeAutocompleteNoResultsTemplate',
        function (_defaultTemplate, templateOptions) {
          triggerAutoCompleteHooksCustomEvent('before-autocomplete-load');
          const { html, state } = templateOptions;

          return html`
            <div id="algolia-autocomplete-panel" class="aa-PanelLayout aa-Panel--scrollable">
              <p class="aa-NoResultsHeader">${algoliaShopify.translation_helpers.no_result_for(state.query)}</p>
              <a class="aa-NoResultsLink" href="${window.Shopify.routes.root}search?q=">
                ${algoliaShopify.translations.allProducts}
              </a>
            </div>
          `;
        },
      );

      // Set and remove title for Products, Pages and Articles sections.
      algoliaShopify.hooks.registerHook(
        'beforeAutocompleteHeaderTemplate',
        function (_defaultTemplate, templateOptions, resource) {
          triggerAutoCompleteHooksCustomEvent('before-autocomplete-load');
          const { html, state } = templateOptions;
          let customHtml = '';
          if (resource === 'Products') {
            customHtml = html`<span class="aa-SourceHeaderTitle aa-ProductsListTitle">Top Products</span>`;
          } else if (resource === 'Pages' || resource === 'Articles') {
            customHtml = '';
          } else {
            return _defaultTemplate;
          }

          return customHtml;
        },
      );

      // Single Product Customization.
      algoliaShopify.hooks.registerHook(
        'beforeAutocompleteProductTemplate',
        function (_defaultTemplate, templateOptions, distinct, itemLink) {
          triggerAutoCompleteHooksCustomEvent('before-autocomplete-load');
          const { html, item, components } = templateOptions;
          const productId = item.id;
          const productDescription = item.body_html_safe?.replace(/&amp;/g, '&');
          const isXlScreen = window.innerWidth <= 1279;
          const okendoReviewSnippet = isXlScreen
            ? item.meta?.okendo?.StarRatingSnippet?.replace(
                /<span class="oke-sr-total-text">\s*\((\d+)\s*Review(s?)\)\s*<\/span>/,
                '<span class="oke-sr-total-text"> ($1)</span>',
              )
            : item.meta?.okendo?.StarRatingSnippet;

          return html`
            <a href="${itemLink}" class="aa-ItemLink aa-ProductItem">
              <div class="aa-ItemContent">
                <div class="aa-ItemPicture aa-ItemPicture--loaded">
                  <img src="${algoliaShopify.helpers.largeImage(item)}" alt="${item.title}" />
                </div>
                <div class="aa-ItemContentBody">
                  ${productId &&
                  okendoReviewSnippet &&
                  html`
                    <div class="aa-ItemReview oke-medium-size">
                      <div data-oke-star-rating data-oke-reviews-product-id="shopify-${productId}">
                        ${html([okendoReviewSnippet])}
                      </div>
                    </div>
                  `}
                  <div class="aa-ItemContentTitleWrapper">
                    <div class="aa-ItemContentTitle">
                      ${components.Highlight({ hit: item, attribute: 'title' })}
                      <span class="algolia-variant">
                        ${algoliaShopify.helpers.variantTitleAddition(item, distinct)}
                      </span>
                    </div>
                  </div>
                  ${productDescription &&
                  html`
                    <div class="aa-ItemDescription">
                      ${(() => {
                        return productDescription.length > 70
                          ? productDescription.substring(0, 67) + '...'
                          : productDescription;
                      })()}
                    </div>
                  `}
                </div>
                <div class="aa-ItemContentPrice">
                  <div class="aa-ItemContentPriceCurrent">${algoliaShopify.helpers.displayPrice(item, distinct)}</div>
                </div>
              </div>
            </a>
          `;
        },
      );
    });
  },

  algoliaInstantSearchEnhance() {
    const body = document.body;

    function aisQuickBuyModal(event, handle = '') {
      event.stopPropagation();
      event.preventDefault();
      if (handle && Alpine.store('quickBuyModal')) {
        Alpine.store('quickBuyModal').loadModal(handle, event);
      } else {
        alert("Sorry, we couldn't load the Quick Buy feature");
      }
    }

    function aisOpenFacetsDrawer(event) {
      event.preventDefault();
      body.classList.add('scroll-lock');
      body.classList.add('ais-show-facets-drawer');
      disableScrollForInputDrawer();
    }

    function aisCloseFacetsDrawer(event) {
      event.preventDefault();
      body.classList.remove('scroll-lock');
      body.classList.remove('ais-show-facets-drawer');
      enableScrollForInputDrawer();
    }

    document.addEventListener('algolia.instantSearch.afterInit', function () {
      if (!window.collectionBannerConfig) return; // Only run when we have the collectionBannerConfig

      const instantSearchWrapper = document.getElementById('algolia-shopify-instantsearch');
      const hitsContainer = instantSearchWrapper?.querySelector('.ais-hits-container');

      if (hitsContainer) {
        const banner = document.createElement('li');
        banner.className = 'ais-Hits-collection-banner';
        banner.innerHTML = `
          <div class="relative bg-cover bg-center h-full w-full" style="${
            window.collectionBannerConfig.background_image
              ? `background-image: url(${window.collectionBannerConfig.background_image});`
              : 'background-color: #F7F2DB;'
          }">
            
            <div class="collection-banner-content h-full flex flex-col justify-between gap-5 text-center">
              <div class="top-content">
                <h2 class="text-white font-serif text-lg lg:text-xl xl:text-3xl tracking-s-wide xl:mb-2">
                  ${window.collectionBannerConfig.title}
                </h2>
                <h3 class="text-white uppercase text-[8px] leading-3 lg:text-xxs xl:text-sm xl:font-bold tracking-x-widest">
                  ${window.collectionBannerConfig.subtitle}
                </h3>
              </div>
              <div class="cta-wrapper">
                <a href="${
                  window.collectionBannerConfig.cta_link
                }" class="inline-block rounded-full uppercase tracking-x-widest text-white border-0"
                  style="background-color: ${window.collectionBannerConfig.cta_background_color}; color: ${
                    window.collectionBannerConfig.cta_color
                  };">
                  ${window.collectionBannerConfig.cta_title}
                </a>
              </div>
            </div>
          </div>
        `;

        const observer = new MutationObserver(() => {
          const hitsList = hitsContainer.querySelector('.ais-InfiniteHits-list');

          if (hitsList) {
            observer.disconnect();

            hitsList.classList.add('has-collection-banner');

            if (hitsList.firstChild) {
              hitsList.insertBefore(banner, hitsList.firstChild);
            } else {
              hitsList.appendChild(banner);
            }
          }
        });

        observer.observe(hitsContainer, { childList: true, subtree: true });
      }
    });

    document.addEventListener('algolia.hooks.initialize', function () {
      const infiniteHits = window.instantsearch?.widgets?.infiniteHits;
      const isCollectionPage = window.location.pathname.includes('/collections/');

      if (infiniteHits) {
        // Remove ais.hits, ais.pagination and ais.searchBox widgets
        algoliaShopify.hooks.registerHook('afterISStartRemoveDefaultWidget', function (defaultWidgets) {
          const hitsWidget = defaultWidgets.find((widget) => widget.$$widgetType === 'ais.hits');
          const paginationWidget = defaultWidgets.find((widget) => widget.$$widgetType === 'ais.pagination');

          if (isCollectionPage) {
            const searchBoxWidget = defaultWidgets.find((widget) => widget.$$widgetType === 'ais.searchBox');
            return [hitsWidget, paginationWidget, searchBoxWidget];
          }

          return [hitsWidget, paginationWidget];
        });

        // Add infiniteHits widget
        algoliaShopify.hooks.registerHook('beforeISStartAddWidgetArray', function () {
          const infiniteHitsWidget = infiniteHits({
            container: '.ais-hits-container',
            templates: {
              item(hit, { html, components }) {
                return window.algoliaShopify.instantsearch.templates.instantSearchProductTemplate(
                  hit,
                  html,
                  components,
                  window.algoliaShopify,
                );
              },
              empty(results, { html }) {
                return window.algoliaShopify.instantsearch.templates.instantSearchNoResultTemplate(
                  html,
                  window.algoliaShopify,
                );
              },
              showMoreText(data, { html }) {
                return html`Load more`;
              },
            },
            transformItems: (items) => {
              const transformedItems = items.map((item) => ({
                ...item,
                _distinct: window.algoliaShopify.instantsearch.distinct,
                can_order: item.inventory_policy === 'continue' || item.inventory_quantity > 0,
                queryID: item.__queryID,
                productPosition: item.__position,
                index: window.algoliaShopify.instantsearch.search.mainIndex.getIndexName(),
              }));
              return transformedItems;
            },
          });

          const configure = window.algoliaShopify?.externals?.widgets?.configure;

          if (configure) {
            const configureWidget = configure({
              facetingAfterDistinct: false, // Set facetingAfterDistinct to false so that proper filters are available on sorting
            });

            return [infiniteHitsWidget, configureWidget];
          }

          return [infiniteHitsWidget];
        });
      }

      algoliaShopify.hooks.registerHook('beforeInstantSearchMainTemplate', function (_defaultTemplate, data, html) {
        const isMdlargeScreen = window.innerWidth <= 799;

        return html`
          <div class="ais-page">
            <h1 class="ais-h2">Search Results</h1>
            <div class="ais-input">
              <div class="ais-search-box-container"></div>
              <div class="ais-input-button">
                <div class="ais-clear-input-icon"></div>
              </div>
            </div>
            <div class="ais-facets-and-blocks">
              <div
                class="ais-facets-backdrop fixed inset-0 z-40 hidden bg-p-forest/70"
                onClick="${(event) => aisCloseFacetsDrawer(event)}"
              ></div>
              <div class="ais-facets">
                <div class="ais-facets--content">
                  <div class="ais-facets--title flex items-center justify-between">
                    Filters
                    <button
                      class="ais-facets-drawer-close hidden"
                      type="button"
                      onClick="${(event) => aisCloseFacetsDrawer(event)}"
                      aria-label="Close panel"
                    >
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M18 6L6 18"
                          stroke="#47483B"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M6 6L18 18"
                          stroke="#47483B"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </button>
                  </div>
                  ${isMdlargeScreen &&
                  html`
                    <div class="ais-sort mdl:hidden">
                      ${data.multipleSortOrders
                        ? html`
                            <span class="ais-sort-text">Sort by</span>
                            <span class="ais-sort-orders-container"></span>
                          `
                        : html` <span class="ais-sort-text">Sorted by</span> ${algoliaShopify.translations.relevance} `}
                    </div>
                  `}
                  ${data.facets.map(
                    (facet) => html`
                      <div class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}">
                        <input
                          class="ais-dropdown-checkbox"
                          type="checkbox"
                          id="${facet.escapedName}"
                          name="dropdown"
                        />
                        <label
                          for="${facet.escapedName}"
                          class="ais-range-slider--header ais-facet--header ais-header select-none"
                        >
                          ${facet.title}
                          <span class="ais-facet--header-icon transition-transform duration-300">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M16.3725 13.125L10.3268 6.875L4.28101 13.125"
                                stroke="#47483B"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </span>
                        </label>
                        <div
                          class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container animate-fade-in"
                        ></div>
                      </div>
                    `,
                  )}
                </div>
              </div>
              <div class="ais-block">
                <div class="ais-search-header hidden">
                  <div class="ais-change-display">
                    <span class="ais-change-display-block ais-change-display-selected">
                      <i class="fa fa-th-large"></i>
                    </span>
                    <span class="ais-change-display-list">
                      <i class="fa fa-th-list"></i>
                    </span>
                  </div>
                </div>
                <div class="ais-block-header">
                  <div class="ais-stats-container"></div>
                  <button
                    class="ais-facets-drawer-button flex shrink-0 items-center gap-x-1 border-b border-p-forest pb-0.5 text-sm font-bold text-p-forest mdl:hidden"
                    type="button"
                    onClick="${(event) => aisOpenFacetsDrawer(event)}"
                  >
                    <span>
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M5 15.625V11.25"
                          stroke="#47483B"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M5 8.75V4.375"
                          stroke="#47483B"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M10 15.625V10"
                          stroke="#47483B"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M10 7.5V4.375"
                          stroke="#47483B"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M15 15.625V12.5"
                          stroke="#47483B"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M15 10V4.375"
                          stroke="#47483B"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M3.125 11.25H6.875"
                          stroke="#47483B"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M8.125 7.5H11.875"
                          stroke="#47483B"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M13.125 12.5H16.875"
                          stroke="#47483B"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                    Filter & Sort
                  </button>
                  <div class="ais-facets-button hidden">Show filters</div>
                  ${!isMdlargeScreen &&
                  html`
                    <div class="ais-sort max-mdl:hidden">
                      ${data.multipleSortOrders
                        ? html`
                            <span class="ais-sort-text">Sort by</span>
                            <span class="ais-sort-orders-container"></span>
                          `
                        : html` <span class="ais-sort-text">Sorted by</span> ${algoliaShopify.translations.relevance} `}
                    </div>
                  `}
                </div>
                <div class="ais-refined-values-wrapper">
                  <div class="ais-current-refined-values-container scrollbar-hide overflow-x-auto"></div>
                  <div class="ais-clear-refinements-container"></div>
                </div>
                <div class="ais-hits-container ais-results-as-block"></div>
              </div>
            </div>
            <div class="ais-pagination-container"></div>
          </div>
        `;
      });

      algoliaShopify.hooks.registerHook(
        'beforeInstantSearchFacetItemTemplate',
        function (_defaultTemplate, item, html) {
          return html`
            <label
              class="${item.cssClasses.label} ${item.type === 'disjunctive'
                ? 'outline-2 outline-offset-2 outline-blue-600 focus:outline-none has-[input:focus-visible]:outline'
                : ''}"
            >
              ${item.type === 'disjunctive' &&
              (item.isRefined
                ? html`
                    <input type="checkbox" class="${item.cssClasses.checkbox} sr-only" checked />
                    <span class="ais-facet--custom-icon">
                      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M15.2222 1H2.77778C1.79594 1 1 1.79594 1 2.77778V15.2222C1 16.2041 1.79594 17 2.77778 17H15.2222C16.2041 17 17 16.2041 17 15.2222V2.77778C17 1.79594 16.2041 1 15.2222 1Z"
                          fill="#47483B"
                          stroke="#47483B"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M14 5.5L7.125 12.5L4 9.31818"
                          stroke="white"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                  `
                : html`
                    <input type="checkbox" class="${item.cssClasses.checkbox} sr-only" />
                    <span class="ais-facet--custom-icon">
                      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M15.2222 1H2.77778C1.79594 1 1 1.79594 1 2.77778V15.2222C1 16.2041 1.79594 17 2.77778 17H15.2222C16.2041 17 17 16.2041 17 15.2222V2.77778C17 1.79594 16.2041 1 15.2222 1Z"
                          stroke="#47483B"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                  `)}
              ${item.type === 'menu' &&
              html`
                <span
                  class="ais-facet--custom-icon flex h-4 w-4 items-center justify-center rounded-full border border-black"
                >
                  <span class="${item.isRefined ? '' : 'hidden'} h-2 w-2 rounded-full bg-p-forest"></span>
                </span>
              `}
              ${item.label}
              <span class="${item.cssClasses.count}"> ${algoliaShopify.helpers.formatNumber(item.count)} </span>
            </label>
          `;
        },
      );

      algoliaShopify.hooks.registerHook('beforeInstantSearchStatsTemplate', function (_defaultTemplate, data, html) {
        return html`
          ${data.hasOneResult && html`Showing ${' '} <span class="font-bold"> 1 </span> item `}
          ${data.hasManyResults &&
          html`
            Showing ${' '}
            <span class="font-bold"> ${Math.min((data.page + 1) * data.hitsPerPage, data.nbHits)} </span>
            ${' '} of ${' '}
            <span class="font-bold"> ${algoliaShopify.helpers.formatNumber(data.nbHits)} </span>
            ${' '} items
          `}
        `;
      });

      algoliaShopify.hooks.registerHook('beforeInstantSearchNoResultTemplate', function (_defaultTemplate, html) {
        return html`
          <div class="ais-hit-empty">
            <div class="ais-hit-empty--title">${algoliaShopify.translations.noResultFound}</div>
            <div class="ais-hit-empty--clears">
              ${algoliaShopify.translations.try} ${' '}
              <a class="ais-hit-empty--clear-filters ais-link"> ${algoliaShopify.translations.clearFilters} ${' '} </a>
              ${!isCollectionPage &&
              html`
                ${algoliaShopify.translations.or} ${' '}
                <a class="ais-hit-empty--clear-input ais-link"> ${algoliaShopify.translations.changeInput} </a>
              `}
            </div>
          </div>
        `;
      });

      algoliaShopify.hooks.registerHook(
        'beforeInstantSearchProductTemplate',
        function (_defaultTemplate, hit, html, components, handleItemClick) {
          const productId = hit.id;
          const productDescription = hit.body_html_safe?.replace(/&amp;/g, '&');
          const okendoReviewSnippet = hit.meta?.okendo?.StarRatingSnippet;
          const productAltObj = { showImage: false, showBadge: false };

          if (hit.meta?.custom?.algolia_alt_image_url) {
            productAltObj.showImage = true;
            productAltObj.image = hit.meta?.custom?.algolia_alt_image_url;
          }

          if (hit.tags && window.productBadgesConfigs) {
            if (Array.isArray(hit.tags)) {
              const badgeTag = hit.tags.find((tag) => tag.includes('badge-'));

              if (badgeTag) {
                const badgeHandle = badgeTag.replace('badge-', '');
                if (window.productBadgesConfigs[badgeHandle]) {
                  productAltObj.showBadge = true;
                  productAltObj.badgeConfig = window.productBadgesConfigs[badgeHandle];
                }
              }
            }
          }

          return html`
            <div
              class="ais-hit ais-product"
              data-algolia-index="${hit.index}"
              data-algolia-position="${hit.productPosition}"
              data-algolia-queryid="${hit.queryID}"
              data-algolia-objectid="${hit.objectID}"
              data-handle="${hit.handle}"
              data-variant-id="${hit.objectID}"
              data-distinct="${hit._distinct}"
              data-product-id="${hit.id}"
              onClick="${(event) => handleItemClick(event, hit)}"
            >
              <div class="ais-hit--picture-wrapper ${productAltObj.showImage ? 'has-alt-picture' : ''}">
                <img class="ais-hit--picture" src="${algoliaShopify.helpers.largeImage(hit)}" alt="${hit.title}" />
                ${productAltObj.showImage &&
                html`
                  <img
                    class="ais-hit--alt-picture"
                    src="${algoliaShopify.helpers.largeImage(productAltObj)}"
                    alt="${hit.title}"
                  />
                `}
                ${productAltObj.showBadge &&
                html`
                  <div class="ais-hit--badge-container">
                    <span
                      style="background-color: ${productAltObj.badgeConfig.backgroundColor}; color: ${productAltObj
                        .badgeConfig.textColor};"
                      class="ais-hit--badge"
                    >
                      ${productAltObj.badgeConfig.text}
                    </span>
                  </div>
                `}
              </div>

              <div class="ais-hit--content">
                ${productId &&
                okendoReviewSnippet &&
                html`
                  <div class="ais-hit--review oke-small-size">
                    <div data-oke-star-rating data-oke-reviews-product-id="shopify-${productId}">
                      ${html([okendoReviewSnippet])}
                    </div>
                  </div>
                `}
                <div class="ais-hit--title">
                  <a
                    data-algolia-index="${hit.index}"
                    data-algolia-position="${hit.productPosition}"
                    data-algolia-queryid="${hit.queryID}"
                    data-algolia-objectid="${hit.objectID}"
                    href="${algoliaShopify.helpers.instantsearchLink(hit)}"
                    onclick="void(0)"
                    title="${algoliaShopify.helpers.fullTitle(hit.title, hit._distinct, hit.variant_title)}"
                  >
                    ${components.Highlight({ attribute: 'title', hit })}
                    ${algoliaShopify.helpers.variantTitleAddition(hit, hit._distinct)}
                  </a>
                </div>
                ${productDescription &&
                html`
                  <div class="ais-hit--description">
                    ${(() => {
                      return productDescription.length > 70
                        ? productDescription.substring(0, 67) + '...'
                        : productDescription;
                    })()}
                  </div>
                `}
              </div>
              <div class="ais-hit--price">
                ${algoliaShopify.helpers.displayPrice(hit, hit._distinct)}
                ${!hit._distinct &&
                html`
                  <span class="ais-hit--price-striked">
                    <span>${algoliaShopify.helpers.displayStrikedPrice(hit.price, hit.compare_at_price)}</span>
                  </span>
                `}
                ${!hit._distinct &&
                html`
                  <span class="ais-hit--price-discount">
                    ${algoliaShopify.helpers.displayDiscount(hit.price, hit.compare_at_price, hit.price_ratio)}
                  </span>
                `}
              </div>
              <button
                type="button"
                class="mt-3 flex w-full items-center justify-center rounded-full border border-[--atc-btn-bg-color] bg-[--atc-btn-bg-color] px-3 py-2 text-xxs font-bold uppercase tracking-x-widest text-[--atc-btn-text-color] outline-offset-4 lg:text-xs xl:mt-5 xl:px-5 xl:py-[13px] xl:text-sm"
                onClick="${event => {
                  const isLowStock = hit.variants_inventory_count < 100;
                  const isBackInStock = hit.tags.includes('back_in_stock');
                  const isInStock = hit.variants_inventory_count !== 0;

                  if ((isLowStock && isBackInStock) || isInStock) {
                    aisQuickBuyModal(event, hit.handle);
                  }
                }}"
              >
                ${hit.tags.includes('back_in_stock')
                  ? 'Quick Buy'
                  : hit.variants_inventory_count === 0
                  ? 'Coming Soon'
                  : 'ADD TO BAG'}
              </button>
            </div>
          `;
        },
      );
    });
  },
});

export const searchComponent = () => ({
  showSearchSuggestions: false,
  showSearchSuggestionsMobile: false,
  searchSuggestions: [],

  init() {
    this.fetchTopSearches();
  },

  hideSuggestions() {
    this.showSearchSuggestions = false;
    this.showSearchSuggestionsMobile = false;
  },

  inputClick(event) {
    const {target} = event;

    if (target?.value?.length < 1) {
      this.showSearchSuggestions = true;
    }
  },

  inputHandler(event) {
    const { inputType, target } = event;

    if (target.value.length === 0) (
      this.showSearchSuggestions = true
    );
  },

  suggestionResizeHandler() {
    if (!window.isMobile) {
      this.hideSuggestions();
    }
  },

  appendSuggestionCloneToMobileSearch() {
    const detachedContainer = document.querySelector('.aa-DetachedContainer');

    if (!detachedContainer) {
      return;
    }

    const mobileSearchSuggestions = document.querySelector('.alglolia-search-suggestions-mobile');

    if (mobileSearchSuggestions) {
      return;
    }

    const searchSuggestions = this.$refs.searchSuggestions.innerHTML;

    detachedContainer.insertAdjacentHTML('beforeend', `
      <div
        class="alglolia-search-suggestions-mobile"
        x-data="{
        showSearchSuggestions: true,
        showSearchSuggestionsMobile: true,
        searchSuggestionData: [${this.searchSuggestions.map(suggestion => `'${suggestion}'`)}],
      }"
      @before-autocomplete-load.window="showSearchSuggestionsMobile = false"
    >
      <template x-if="showSearchSuggestionsMobile">
        <div class="relative bg-p-ivory p-4 capitalize shadow-lg lg:px-16 lg:py-8" x-ref="searchSuggestions">
          <div class="m-auto w-full max-w-[1000px]">
            <h3 class="mb-4 font-sans font-bold md:text-base">Popular Search Terms</h3>
            <ul id="topresults" class="list-none">
              <template x-for="suggestion in searchSuggestionData">
                <li class="inline-block mr-4 mb-4">
                  <a :href="'/search?q=' + suggestion" class="btn--small btn--solid btn btn--secondary capitalize tracking-normal" x-text="suggestion"></a>
                </li>
              </template>
            </ul>
          </div>
        </div>
      </template>
    </div>`);

  },
  sanitizeSearchTerm(search) {
    return search.replace(/["'\\\n\r\t\b\f]/g, (char) => {
      const escapeMap = {
          '"': '\\"', "'": "\\'", "\\": "\\\\", "\n": "\\n",
          "\r": "\\r", "\t": "\\t", "\b": "\\b", "\f": "\\f"
      };
      return escapeMap[char] || char;
    });
  },
  fetchTopSearches() {
    const apiKey = '6603de15f2cc42b8d6b460ce0f473d86'; // Replace with your Algolia API Key
    const appId = 'J4W35K0ZQZ'; // Replace with your Algolia Application ID
    const {index_prefix} = window.algoliaShopify?.config; // Replace with your index name
    const indexName = index_prefix ? `${index_prefix}products` : 'shopify_products'; // Replace with your index name
    const limit = window.themeTopSearches?.algoliaSearchesCount || 10; // Number of results to return
    const customSearches = window.themeTopSearches?.customSearches || [];
    const sanitizedCustomSearches = customSearches.map((item) => this.sanitizeSearchTerm(item))

    const url = `https://analytics.us.algolia.com/2/searches?index=${indexName}&limit=${limit}`;

    (async () => {
      try {
        const response = await fetch(url, {
          method: 'GET',
          headers: {
            'X-Algolia-API-Key': apiKey,
            'X-Algolia-Application-Id': appId,
          },
        });

        if (!response.ok) {
          throw new Error(`Error: ${response.status} ${response.statusText}`);
        }

        const data = await response.json();
        
        const algoliaSearchSuggestions = [...data.searches]
            .filter(({ search }) => search.trim() !== '')
            .sort((a, b) => b.count - a.count)
            .map(({ search }) => {
              return this.sanitizeSearchTerm(search)
            });

        this.searchSuggestions = [
          ...sanitizedCustomSearches,
          ...algoliaSearchSuggestions,
        ]


      } catch (error) {
        console.error('Failed to fetch top searches:', error);
      }
    })();
  },
});
